import { Box } from "@chakra-ui/react"
import { ReactComponent as Construction } from '../svg/warning-construction.svg'

export default function NotFound() {
    return (
        <Box
            d='flex'
            justifyContent='center'
            alignItems='center'
            minH='90vh'
        >
            <Construction width = '300px' height = '300px'/>
        </Box>
    )
}